
// third party
import mySuxApi from '../services/dataSources/mySuxApi';

// constants
import * as ACTIONS from './constants';

// services
import { deleteUserCookies } from '../services/cookieService';
import { getUserDetails, updateUserDetails } from '../services/UserService';
import { exponeaIdentify, exponeaAnonymize } from '../services/exponeaService'; 

// config
import { config } from '../config';

import store from '../store';

const URLS = config.URLS;

export const logoutUser = () => (dispatch) => {
  deleteUserCookies();
  exponeaAnonymize();
  dispatch({ type: ACTIONS.USER_LOG_OUT });
};

export const loginUser = user => (dispatch) => {
  if(store.getState().sofologist.Authorized) {
    exponeaIdentify(user.retailExperienceUser.userId);
  }
  dispatch({ type: ACTIONS.USER_LOG_IN, payload: user });
};

// new hotness get user
export const getUser = () => (dispatch, getState) => {
  const { userGuid } = getState().user;
  getUserDetails(userGuid).then(user => dispatch({
    type: ACTIONS.USER_UPDATE_DETAILS,
    payload: user
  }));
};


export const requestPasswordReset = email => () => {
  const url = `${URLS.MY_ACCOUNT_URL}user/password/reset`;
  return mySuxApi.post(url, { email });
};

export const changePhoneNumber = (newNumber, type) => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/User/${userId}`;
  const data = {};
  data[type] = newNumber;
  return mySuxApi.post(url, data)
    .then((res) => {
      if (!res || res === false) return Promise.reject('failed to update phone numbers');
      dispatch(getUserDetails());
      return true;
    }
    );
};

export const updateUser = newData => (dispatch, getState) => {
  const { userGuid } = getState().user;
  return updateUserDetails(userGuid, newData)
    .then((res) => {
      dispatch(getUser());
      return res;
    });
};


// old ass busted


// export const __OLD__updateUser = user => (dispatch, getState) => {
//   const { userGuid, userId } = getState().user;
//   const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/User/${userId}`;
//   return mySuxApi.post(url, user)
//     .then((res) => {
//       if (!res || res === false) return Promise.reject('failed to update user');
//       dispatch(getUserDetails());
//       return true;
//     }
//     );
// };

// deprecated for intillery page til a later date!
export const updatePermissions = newPermissions => (dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/User/${userId}`;
  return mySuxApi.post(url, newPermissions)
    .then(() => dispatch(getUserDetails()));
};

// TODO: get rid of me!!!
// export const __OLD__getUserDetails = () => (dispatch, getState) => {
//   const { userGuid, userId } = getState().user;
//   const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/User/${userId}`;
//   return mySuxApi.get(url).then(({ data }) => {
//     if (!data || data === null) {
//       dispatch({ type: ACTIONS.USER_ADD_ADDRESS, payload: false });
//       return;
//     }
//     const address = {
//       customerFirstName: data.FirstName,
//       customerLastName: data.LastName,
//       billingAddress: {
//         address1: data.AddressLine1,
//         address2: data.AddressLine3,
//         city: data.AddressLine2,
//         postalCode: data.PostCode,
//         country: 'GB'
//       },
//       title: data.Title,
//       email: data.Email,
//       textTel: data.TextTel,
//       telephone1: data.Telephone1,
//       telephone2: data.Telephone2
//     };
//     const permissions = {
//       canEmail: data.CanEmail,
//       canText: data.CanText
//     };
//     dispatch({ type: ACTIONS.USER_UPDATE, payload: { address, permissions } });
//   });
// };



// WEBPACK FOOTER //
// ./src/actions/user.js